import React from 'react';
import { useMobileContext } from '../../contexts/MobileContext';
import PageShell from '../Layout/PageShell';
import SubPageHero from './SubPageHero';

import ScrollFadeWrapper from '../ScrollFadeWrapper/ScrollFadeWrapper';
import QuoteCarouselComponent from '../HomePage/QuoteCarousel/QuoteCarouselComponent';

import PartnerBrandsComponent from '../HomePage/PartnerBrands/PartnerBrandsComponent';
import PartnerBrandsMobileComponent from '../HomePage/PartnerBrands/PartnerBrandsMobileComponent';
import partnerBrandsData from '../../json/components/HomePages/MedicalAid/partnerBrandsData.json';

import CustomerReviewsComponent from '../HomePage/CustomerReviews/CustomerReviewsComponent';
import CustomerReviewsMobileComponent from '../HomePage/CustomerReviews/CustomerReviewsMobileComponent';
import customerReviewsData from '../../json/components/HomePages/MedicalAid/customerReviewsData.json';

import KeyPointVerticalNumericComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalNumericComponent';
import KeyPointVerticalNumericFourMobileComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalNumericFourMobileComponent';
import keyPointVerticalNumericData from '../../json/components/HomePages/MedicalAid/keyPointVerticalNumericData.json';

import ExpertQuotesComponent from '../HomePage/ExpertQuotes/ExpertQuotesComponent';
import ExpertQuotesMobileComponent from '../HomePage/ExpertQuotes/ExpertQuotesMobileComponent';
import expertQuotesData from '../../json/components/HomePages/MedicalAid/expertQuotesData.json';
import expertQuotesData2 from '../../json/components/HomePages/MedicalAid/expertQuotesData2.json';

import AccordionFAQComponent from '../HomePage/AccordionFAQ/AccordionFAQComponent';
import AccordionFAQMobileComponent from '../HomePage/AccordionFAQ/AccordionFAQMobileComponent';
import accordionFAQData from '../../json/components/HomePages/MedicalAid/accordionFAQData.json';

import SeoDetailMedicalAidModuleComponent from '../HomePage/SeoDetailModule/SeoDetailMedicalAidModuleComponent';
import SeoDetailMedicalAidModuleMobileComponent from '../HomePage/SeoDetailModule/SeoDetailMedicalAidModuleMobileComponent';
import seoDetailMedicalAidData from '../../json/components/HomePages/MedicalAid/seoDetailMedicalAidData.json';
import SectionStepsIconComponent from '../HomePage/SectionSteps/SectionStepsIconComponent';
import SectionStepsIconMobileComponent from '../HomePage/SectionSteps/SectionStepsIconMobileComponent';
import sectionStepsIconData from '../../json/components/HomePages/MedicalAid/sectionStepsIconData.json';
import ScrollingCardsComponent from '../HomePage/ScrollingCards/ScrollingCardsComponent';
import ScrollingCardsMobileComponent from '../HomePage/ScrollingCards/ScrollingCardsMobileComponent';
import scrollingCardsData from '../../json/components/HomePages/MedicalAid/scrollingCardsData.json';
import scrollingCardsDataShort from '../../json/components/HomePages/MedicalAid/scrollingCardsDataShort.json';

import FourBlogCardsComponent from '../HomePage/FourBlogCards/FourBlogCardsComponent';
import FourBlogCardsMobileComponent from '../HomePage/FourBlogCards/FourBlogCardsMobileComponent';
import fourBlogCardsData from '../../json/components/HomePages/MedicalAid/fourBlogCardsData.json';

import HippoSubLineGenericComponent from '../../components/Banners/HippoSubLineGenericComponent';
import HippoSubLineGenericMobileComponent from '../../components/Banners/HippoSubLineGenericMobileComponent';
import HippoGenericMobileComponent from '../../components/Banners/HippoGenericMobileComponent';
import HippoTwoLineGenericComponent from '../../components/Banners/HippoTwoLineGenericComponent';

function MedicalAidPage({ pathName, heroGateKey, onHeroImageLoad }) {
  const isMobile = useMobileContext();
  const questionRoute = '/medical-aid-quote/step1';

  return (
    <PageShell gap={{ xs: '24px', sm: '48px', md: '64px' }}>
      <SubPageHero
        pathName={pathName}
        heroGateKey={heroGateKey}
        onImageLoad={onHeroImageLoad}
      />

      <QuoteCarouselComponent
        crossSellKey="latestMedicalAidQuotes_CrossSell"
        fallbackKey="latestMedicalAidQuotes"
        navigateTo="/medical-aid-quote/step1"
      />

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <PartnerBrandsComponent data={partnerBrandsData} />
        ) : (
          <PartnerBrandsMobileComponent data={partnerBrandsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ExpertQuotesComponent expertData={expertQuotesData2} />
        ) : (
          <ExpertQuotesMobileComponent expertData={expertQuotesData2} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <KeyPointVerticalNumericComponent
            data={keyPointVerticalNumericData}
          />
        ) : (
          <KeyPointVerticalNumericFourMobileComponent
            data={keyPointVerticalNumericData}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={'/blog/health/medical-scheme-awards/'}
            imageDirection={'left'}
            image={'HippoBannerChamp'}
            color={'blue'}
            title={'Turns out, medical aids like us too'}
            buttonText={'View awards'}
            buttonColor={'green'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={'/blog/health/medical-scheme-awards/'}
            image={'HippoBannerChamp'}
            color={'blue'}
            title={'Turns out, medical aids like us too'}
            buttonText={'View awards'}
            buttonColor={'green'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CustomerReviewsComponent data={customerReviewsData} />
        ) : (
          <CustomerReviewsMobileComponent data={customerReviewsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={'/blog/health/taking-the-tax-out-of-medical-expenses/'}
            imageDirection={'left'}
            image={'HippoBannerChamp'}
            color={'blue'}
            title={'Medical aid members qualify for tax relief'}
            buttonText={'Medical Tax Credits'}
            buttonColor={'green'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={'/blog/health/taking-the-tax-out-of-medical-expenses/'}
            image={'HippoBannerChamp'}
            color={'blue'}
            title={'Medical aid members qualify for tax relief'}
            buttonText={'Medical Tax Credits'}
            buttonColor={'green'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <SeoDetailMedicalAidModuleComponent data={seoDetailMedicalAidData} />
        ) : (
          <SeoDetailMedicalAidModuleMobileComponent
            data={seoDetailMedicalAidData}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={questionRoute}
            image={'HippoGottcha'}
            imageDirection={'right'}
            title={'Your easiest way to find better medical aid'}
            color={'blue'}
            buttonText={'Compare now'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={questionRoute}
            image={'HippoGottcha'}
            title={'Your easiest way to find better medical aid'}
            color={'blue'}
            buttonText={'Compare now'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <SectionStepsIconComponent data={sectionStepsIconData} />
        ) : (
          <SectionStepsIconMobileComponent data={sectionStepsIconData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsDataShort} />
        ) : (
          <ScrollingCardsMobileComponent data={scrollingCardsDataShort} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ExpertQuotesComponent expertData={expertQuotesData} />
        ) : (
          <ExpertQuotesMobileComponent expertData={expertQuotesData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <FourBlogCardsComponent data={fourBlogCardsData} tag="medical-aid" />
        ) : (
          <FourBlogCardsMobileComponent
            data={fourBlogCardsData}
            tag="medical-aid"
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoSubLineGenericComponent
            route={'/medical-aid-quote/guide-to-medical-aid/'}
            image={'HippoThinkTilt'}
            imageDirection={'left'}
            title={'Take the guesswork out\nof medical aid'}
            color={'blue-white'}
            buttonText={'View guide'}
            buttonColor={'green'}
          />
        ) : (
          <HippoSubLineGenericMobileComponent
            route={'/medical-aid-quote/guide-to-medical-aid/'}
            image={'HippoThinkTilt'}
            title={'Take the guesswork out of medical aid'}
            buttonText={'View guide'}
            buttonColor={'green'}
            color={'blue'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <AccordionFAQComponent data={accordionFAQData} />
        ) : (
          <AccordionFAQMobileComponent data={accordionFAQData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsData} />
        ) : (
          <ScrollingCardsMobileComponent data={scrollingCardsData} />
        )}
      </ScrollFadeWrapper>
    </PageShell>
  );
}

export default MedicalAidPage;
